// import { createSelector } from 'reselect';

// 按菜单分组权限
export const permissionMenuGroupState = ({ permission }) =>
  permission.permissions.reduce((acc, item) => {
    const data = acc[item.menu] || (acc[item.menu] = []);
    data.push(item);
    return acc;
  }, {});

export const hasPermissionSelector = state => {
  const permissionGroup = permissionMenuGroupState(state);
  return permission => {
    const { menu } = permission;
    let permissions = permissionGroup[menu] || [];
    if (menu)
      permissions = permissions.concat(permissionGroup['undefined'] || []);
    return permissions.some(item =>
      Object.keys(permission).every(key => permission[key] === item[key])
    );
  };
};
